<template>
  <div v-if="release" class="gp-content">
    <transition name="fade" mode="out-in">
      <router-view :release="release"></router-view>
    </transition>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'Release',
  computed: {
    ...mapState('admin', ['release']),
  },
  async mounted() {
    await this.$store.dispatch('admin/getRelease', {
      uuid: this.$route.params.id,
    });
  },
};
</script>

<style lang="scss" scoped>
</style>
